import { Card } from "./ui/card";

export const KpiCard = ({
    label,
    value,
    sub,
    hint,
    icon: Icon,
    testid,
    accent = false,
}) => (
    <Card
        data-testid={testid}
        className={`relative overflow-hidden p-5 hover:-translate-y-0.5 transition-transform border ${
            accent ? "border-accent/40" : "border-border"
        }`}
    >
        <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
                <div className="text-[11px] uppercase tracking-[0.16em] text-muted-foreground font-medium">
                    {label}
                </div>
                <div className="kpi-value text-5xl mt-3 text-foreground">
                    {value}
                </div>
                {sub && (
                    <div className="mt-2 text-xs text-muted-foreground font-medium">
                        {sub}
                    </div>
                )}
            </div>
            {Icon && (
                <div className="w-9 h-9 rounded-md bg-muted flex items-center justify-center text-muted-foreground shrink-0">
                    <Icon className="w-4 h-4" />
                </div>
            )}
        </div>
        {hint && (
            <div className="mt-4 pt-3 border-t border-border/60 text-[11px] text-muted-foreground leading-relaxed">
                {hint}
            </div>
        )}
    </Card>
);
